import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const StyledDate = styled.span `
    display: block;
    margin-bottom: 5px;
    color: #8d8d8d;
    font-size: 15px;
`;
const MessageDate = ({ children }) => (_jsx(StyledDate, { children: children }));
export default MessageDate;
